// Breadcrumbs and other single-line chrome get the real project name, but a
// long name would push its neighbours off the row — cut it and let callers
// keep the full name as a tooltip.
export const BREADCRUMB_NAME_MAX = 28;

export const truncateName = (name: string, max: number = BREADCRUMB_NAME_MAX): string =>
  name.length > max ? name.slice(0, max).trimEnd() + '…' : name;
